import $ from 'jquery';
import ads from './ads'
import socialMedia from './social-media'
import Recaptcha from "./recaptcha";
import OneSignal from "./one-signal"

const domEvents = {};

/**
 * Specific method to listen scroll only once
 * 
 */
const oneUseScrollEvents = () => {
    if (document.readyState === 'complete' && window.pageYOffset >= 0 ) {
        setUpScrollEvents();
    }
};

const setUpScrollEvents = () => {
    //socialMedia.init();
    (new OneSignal()).domInjection("b9235ba2-8772-462c-8746-3f2db24fa1c7");
    (new Recaptcha()).domInjection();

    // Remove listener for one use purpose
    document.removeEventListener('scroll', oneUseScrollEvents)
};

/**
 * Method to force display ads as soon the pages has been loaded
 */
const forceScrollToDisplayAds = () => {
    window.scrollTo(window.pageXOffset, window.pageYOffset + 1)
};

/**
 * Bind dom events here
 */
const bindEvents = () => {
    document.addEventListener('scroll', oneUseScrollEvents)
    
    // More events should be here
};

domEvents.init = () => {
    bindEvents();
    ads.init();

    if ($("body").height() > $(window).height()) {
        forceScrollToDisplayAds();
    } else {
        setUpScrollEvents();
    }

};

export default domEvents